import { ErrorMessage, Field, Formik } from "formik";
import { TextField } from "formik-mui";
import React from "react";
import XCancel from "../../XCancel";
import { GroupSchema, initialGroup } from "../../../schemas/CommunitySchema";
import useUploadDocument from "../../../hooks/useUploadDoc";
import { useGroup } from "../../../context/GroupContext";
import Spinner from "../../Loader/Spinner";

const EditGroup = ({ close }) => {
    const { doc, setUrl, onChange } = useUploadDocument();
    const { openedGroup, updategroup, setLoader, loading } = useGroup();

    const submitHandler = async (values, { resetForm }) => {
        await updategroup({ ...values, image: doc.url ? doc?.url : openedGroup?.image }, openedGroup?.id)
        resetForm();
        close();
    };

    const addImage = async (e) => {
        if (!e.target.files) return;
        await onChange(e, 'groups', setLoader);
        setUrl(null);
    }

    return (
        <>
            {" "}
            <XCancel close={close} />
            <div className="px-[40px] pb-[32px] w-[300px] md:w-[536px] h-[auto]">
                <div className="w-full h-full flex flex-col items-center justify-center">
                    <Formik onSubmit={submitHandler} initialValues={{
                        ...initialGroup, groupName: openedGroup?.name, description: openedGroup?.description
                    }} validationSchema={GroupSchema}>
                        {({ handleSubmit, values }) => (
                            <>
                                <p className="text-[#1A1D4D] font-black text-[16px]">Edit Group</p>
                                <div className="w-full flex flex-col items-center justify-center ">
                                    <div className="pt-8 w-full md:w-[352px]">
                                        <label htmlFor="imageUpload">
                                            <div className="flex flex-col text-[#ACACAC] h-[73px] gap-1 px-6 py-[20px] rounded-xl items-center justify-center border-dashed border-primary border-[1.4px]">
                                                <p className="text-[14px] ">
                                                    <i className="fa-solid fa-circle-plus mr-1 "></i>
                                                    Add Photo
                                                </p>
                                            </div>
                                        </label>
                                        <input
                                            id="imageUpload"
                                            type="file"
                                            className="w-0.1 h-0.1 overflow-hidden hidden"
                                            onChange={addImage}
                                        />
                                        <ErrorMessage
                                            name={"image"}
                                            render={(msg) => <div className="text-[0.7812rem] text-red-400 text-left font-normal">{msg}</div>}
                                        />
                                    </div>
                                    <div className="pt-6">
                                        <div className="mt-1 relative flex md:justify-end">
                                            <Field
                                                name={"groupName"}
                                                label="Group Name"
                                                value={values.groupName || ""}
                                                placeholder="Group Name"
                                                component={TextField}
                                                className="border w-full md:w-[352px] h-[50px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                                            />
                                        </div>
                                        <ErrorMessage
                                            name={"groupName"}
                                            render={(msg) => <div className={"text-[0.7812rem] text-red-600 text-left font-normal"}>{msg}</div>}
                                        />{" "}
                                    </div>
                                    <div className="pt-6">
                                        <div className="mt-1 relative flex md:justify-end">
                                            <Field
                                                name={"description"}
                                                component={TextField}
                                                label="Description"
                                                value={values.description || ""}
                                                placeholder="Description"
                                                multiline
                                                rows={6}
                                                as="textarea"
                                                className="border w-full md:w-[352px] h-[200px] py-4  border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                                            />
                                        </div>
                                        <ErrorMessage
                                            name={"description"}
                                            render={(msg) => <div className={"text-[0.7812rem] text-red-600 text-left font-normal text-jumbleng-gray-main"}>{msg}</div>}
                                        />{" "}
                                    </div>
                                    <button
                                        onClick={handleSubmit}
                                        className="w-[200px] md:w-[300px] h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold"
                                    >
                                        {loading ? <Spinner /> : "Update"}
                                    </button>
                                </div>
                            </>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    );
};

export default EditGroup;
